import axios from "./axios";
import { handleApiError } from "./handleApiError";

export interface AdminSearchUsersResult {
  id: string;
  name: string;
  email: string;
  roles: string[];
}

export interface AdminSearchContentResult {
  id: string;
  title: string;
  author?: string;
  slug?: string;
  isApproved?: boolean;
  submissionStatus?: string;
  submissionStatusReason?: string | null;
}

export interface AdminSearchPartResult {
  id: string;
  title: string;
  order?: number;
  contentId?: string;
  contentTitle?: string;
  isApproved?: boolean;
}

export interface AdminSearchPurchaseResult {
  id: string;
  kind: string;
  title: string;
  subtitle?: string;
  status?: string;
  amount?: number;
  currency?: string;
  createdAtUtc?: string;
}

export interface AdminSearchPayoutResult {
  id: string;
  kind: string;
  title: string;
  subtitle?: string;
  status?: string;
  amount?: number;
  currency?: string;
  createdAtUtc?: string;
}

export interface AdminSearchResponse {
  users: AdminSearchUsersResult[];
  contents: AdminSearchContentResult[];
  parts: AdminSearchPartResult[];
  purchases: AdminSearchPurchaseResult[];
  payouts: AdminSearchPayoutResult[];
}

export async function searchAdminEntities(query: string, scope?: string): Promise<AdminSearchResponse> {
  if (!query.trim()) {
    return { users: [], contents: [], parts: [], purchases: [], payouts: [] };
  }

  try {
    const res = await axios.get("/admin/search", {
      params: {
        q: query.trim(),
        scope,
        take: 6,
      },
    });

    const data = res.data ?? {};
    return {
      users: Array.isArray(data.users) ? data.users : [],
      contents: Array.isArray(data.contents) ? data.contents : [],
      parts: Array.isArray(data.parts) ? data.parts : [],
      purchases: Array.isArray(data.purchases) ? data.purchases : [],
      payouts: Array.isArray(data.payouts) ? data.payouts : [],
    };
  } catch (error) {
    return handleApiError(error, "searchAdminEntities", { users: [], contents: [], parts: [], purchases: [], payouts: [] });
  }
}
